import { render, staticRenderFns } from "./forget_password.vue?vue&type=template&id=37e6d93a&"
import script from "./forget_password.vue?vue&type=script&lang=js&"
export * from "./forget_password.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports